import React from 'react';
import { useSEO } from '../contexts/SEOContext';
import VariantBlog from './variants/VariantBlog';

const Blog = () => {
  const { currentSEO } = useSEO();
  
  return (
    <div>
      <VariantBlog />
    </div>
  );
};

export default Blog; 